// extracted by mini-css-extract-plugin
export default {"podcast":"PodcastLicenseContainer-module_podcast__NCP39"};